/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function techSlider() {

  var slider = document.querySelector('.tech__slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    adaptiveHeight: false,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var tapArea, startX;
  tapArea = document.querySelectorAll('.tech__slider');
  startX = 0;
  for (var item of tapArea) {
    item.ontouchstart = function (e) {
      startX = e.touches[0].clientX;
    };
    item.ontouchmove = function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
        e.preventDefault();
      }
    };
  }
}
